import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import axios from "axios";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import {
  getEmailTemplateAction,
  getSmsNotificationListAction,
  getSmsTemplateAction,
  makrSmsReadResponse,
  markSmsReadAction,
  sendEmailTemplateAction,
  sendLogEmailAction,
  sendSmsTemplateAction,
  setEmailTemplateAction,
  setLogEmailResponseDataAction,
  setSendEmailTemplateAction,
  setSendLogEmailResponseAction,
  setSendSmsTemplateAction,
  setSmsNotificationListResponse,
  setSmsTemplateAction,
} from "../reducers/templateSlice";
import { getSingleLeadAction } from "../reducers/leadSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getSmsTemplateSaga(): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const temp = yield call<any>(callAPI, {}, "get", "client/template/sms");
    console.log("temp-", temp);
    if (temp?.data) {
      yield put(setSmsTemplateAction(temp?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* sendSmsTemplateSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/send-sms",
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setSendSmsTemplateAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setSendSmsTemplateAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getEmailTemplateSaga(): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const temp = yield call<any>(callAPI, {}, "get", "client/template/emails");
    console.log("temp-", temp);
    if (temp?.data) {
      yield put(setEmailTemplateAction(temp?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setSendSmsTemplateAction(false));
  }
  yield put(setLoaderAction(false));
}

function* sendEmailTemplateSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/send-email",
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setSendEmailTemplateAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setSendEmailTemplateAction(false));
  }
  yield put(setLoaderAction(false));
}

function* sendLogEmailSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { id } = payload?.payload || {};
    yield put(setLogEmailResponseDataAction(null));
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `client/emails/${id}`,
    );
    if (apiResponse?.success === true) {
      yield put(setLogEmailResponseDataAction(apiResponse?.data || null));
      yield put(setSendLogEmailResponseAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setLogEmailResponseDataAction(null));
    yield put(setSendLogEmailResponseAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getSmsNotificationListSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { page, limit, orderBy, orderIn } = payload.payload;
  try {
    const temp = yield call<any>(
      callAPI,
      {},
      "get",
      `leads/sms-logs?page=${page}&limit=${limit ?? 10}`,
    );
    if (temp?.data) {
      yield put(setSmsNotificationListResponse(temp?.data));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* markSmsReadSga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    console.log("payload",payload);
    const { ids } = payload?.payload || {};
    const apiResponse = yield call<any>(
      callAPI,
      { payload:{ids:ids} },
      "post",
      `leads/sms-logs/mark-read`,
    );
    if (apiResponse?.success === true) {
      yield put(makrSmsReadResponse(true));
    } else {
      yield put(makrSmsReadResponse(false));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(makrSmsReadResponse(false));
  }
  yield put(setLoaderAction(false));
}

export function* watchTemplate() {
  yield takeLatest<any>(getSmsTemplateAction, getSmsTemplateSaga);
  yield takeLatest<any>(sendSmsTemplateAction, sendSmsTemplateSaga);
  yield takeLatest<any>(getEmailTemplateAction, getEmailTemplateSaga);
  yield takeLatest<any>(sendEmailTemplateAction, sendEmailTemplateSaga);
  yield takeLatest<any>(sendLogEmailAction, sendLogEmailSaga);
  yield takeLatest<any>(
    getSmsNotificationListAction,
    getSmsNotificationListSaga,
  );
  yield takeLatest<any>(markSmsReadAction,markSmsReadSga);
}
